function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { MultiSelectFilterPicker } from 'seagull';
import { useIoContext } from "../../../../providers/IoContext";
import DateRangeFilterPicker from "../DateRangeFilterPicker/DateRangeFilterPicker";
import DateRangeWithPresets from "../DateRangeWithPresets/DateRangeWithPresets";
import RadioFilterPicker from "../RadioFilterPicker/RadioFilterPicker";
import { SearchFilterType } from "../types";
import { jsx as _jsx } from "react/jsx-runtime";
const Filter = _ref => {
  let {
    testIdPrefix,
    label,
    filter,
    filterConfig,
    selectedFilter,
    onChange,
    onRemove,
    onInputBlur,
    onInputFocus
  } = _ref;
  const {
    getNow
  } = useIoContext();
  const now = getNow();
  const getFilterPicker = () => {
    var _filterConfig$options, _filterConfig$options2;
    switch (filterConfig.type) {
      case SearchFilterType.DateRangeFilter:
        return /*#__PURE__*/_jsx(DateRangeFilterPicker, _objectSpread({
          value: selectedFilter,
          onChange: onChange,
          onRemove: onRemove,
          "data-testid": "".concat(testIdPrefix, "-filter-").concat(filter),
          label: label,
          onInputFocus: onInputFocus,
          onInputBlur: onInputBlur,
          startOpen: !!selectedFilter && filterConfig.removable
        }, filterConfig));
      case SearchFilterType.MultiSelectFilter:
        return /*#__PURE__*/_jsx(MultiSelectFilterPicker, {
          withSearchbox: filterConfig.withSearchbox,
          removable: filterConfig.removable,
          value: selectedFilter,
          "data-testid": "".concat(testIdPrefix, "-filter-").concat(filter),
          title: filterConfig.title || label,
          options: ((_filterConfig$options = filterConfig.options) === null || _filterConfig$options === void 0 ? void 0 : _filterConfig$options.map(option => typeof option === 'string' ? {
            value: option,
            label: option
          } : option)) || [],
          label: label,
          onChange: onChange,
          onRemove: onRemove,
          onInputFocus: onInputFocus,
          startOpen: !!selectedFilter && filterConfig.removable,
          onInputBlur: onInputBlur,
          selectAllByDefault: filterConfig.selectAllByDefault
        });
      case SearchFilterType.DateRangeWithPresets:
        return /*#__PURE__*/_jsx(DateRangeWithPresets, {
          now: now,
          startDate: selectedFilter.dateRange[0],
          endDate: selectedFilter.dateRange[1],
          dataRangeOption: selectedFilter.dateRangeOption,
          customDateLimits: filterConfig.customDateLimits,
          onApply: (dataRange, startDate, endDate) => {
            onChange({
              dateRange: [startDate, endDate],
              dateRangeOption: dataRange
            });
          },
          onRemove: onRemove,
          removable: filterConfig.removable,
          testIdPrefix: testIdPrefix,
          title: label,
          startOpen: filterConfig.startOpen
        });
      case SearchFilterType.RadioFilter:
        return /*#__PURE__*/_jsx(RadioFilterPicker, {
          selectedValue: selectedFilter,
          defaultLabel: label,
          title: filterConfig.title || label,
          testId: "".concat(testIdPrefix, "-filter-").concat(filter),
          options: ((_filterConfig$options2 = filterConfig.options) === null || _filterConfig$options2 === void 0 ? void 0 : _filterConfig$options2.map(option => typeof option === 'string' ? {
            value: option,
            label: option
          } : option)) || [],
          onApply: aggregate => onChange(aggregate),
          setValue: aggregate => onChange(aggregate),
          onRemove: onRemove,
          removable: filterConfig.removable,
          startOpen: !!selectedFilter && filterConfig.removable
        });
    }
  };
  return /*#__PURE__*/_jsx("div", {
    "data-testid": "".concat(testIdPrefix, "-filter-").concat(filter),
    children: getFilterPicker()
  });
};
export default Filter;